export default "__VITE_ASSET__EnhNCiVg__"